export enum MessageSource {
  BUTTON = 'button',
  CHAT = 'chat',
  GREETING = 'greeting',
}

export enum ButtonMessageType {
  BUTTON_READY = 'buttonReady',
  SETTINGS_LOADED = 'settingsLoaded',
  TOGGLE_CHAT = 'toggleChat',
  BUTTON_DRAG_START = 'buttonDragStart',
  BUTTON_DRAG_MOVE = 'buttonDragMove',
  BUTTON_DRAG_END = 'buttonDragEnd',
}

export enum GreetingMessageType {
  TOGGLE_CHAT = 'toggleChat',
  DISMISS_GREETING = 'dismissGreeting',
  GREETING_READY = 'greetingReady',
  RESIZE_GREETING = 'resizeGreeting',
}

export enum ChatMessageType {
  READY = 'ready',
  INITIALIZED = 'initialized',
  ERROR = 'error',
  CLOSE = 'close',
  UNREAD_COUNT = 'unreadCount',
  VOICE_CALL_STATUS = 'voiceCallStatus',
  VOICE_CALL_MUTED = 'voiceCallMuted',
  CHAT_STATE_CHANGE = 'chatStateChange',
  CHAT_VISIBLE = 'chatVisible',
}
